var map = {
	"./assets/font/Montserrat-Bold.ttf": 3035,
	"./assets/font/Montserrat-Medium.ttf": 3311,
	"./assets/font/Montserrat-Regular.ttf": 7714,
	"./assets/img/HOMEPAGE_IMAGES.md": 3524,
	"./assets/img/boxing_team_pic.jpg": 8744,
	"./assets/img/boxing_team_pic2.JPG": 2017,
	"./assets/img/esthetic_picture_ofme1.jpg": 4315,
	"./assets/img/esthetic_picture_ofme2.jpg": 7868,
	"./assets/img/icons/MenuIcon.svg": 5761,
	"./assets/img/icons/aichat.png": 6393,
	"./assets/img/icons/angular.svg": 5495,
	"./assets/img/icons/arabic.png": 5925,
	"./assets/img/icons/arrow1.svg": 8459,
	"./assets/img/icons/arrow2.svg": 7720,
	"./assets/img/icons/c.svg": 8626,
	"./assets/img/icons/calender.png": 451,
	"./assets/img/icons/cpp.svg": 3666,
	"./assets/img/icons/css.svg": 9588,
	"./assets/img/icons/d3.svg": 1524,
	"./assets/img/icons/deeplearning.svg": 5859,
	"./assets/img/icons/devpost.png": 6402,
	"./assets/img/icons/discord.png": 8961,
	"./assets/img/icons/discord.svg": 9225,
	"./assets/img/icons/django.svg": 7734,
	"./assets/img/icons/dsa.svg": 8909,
	"./assets/img/icons/email.png": 297,
	"./assets/img/icons/english.svg": 1101,
	"./assets/img/icons/express.svg": 7697,
	"./assets/img/icons/flask.svg": 7620,
	"./assets/img/icons/framermotion.svg": 622,
	"./assets/img/icons/french.svg": 7731,
	"./assets/img/icons/github.png": 1872,
	"./assets/img/icons/github.svg": 50,
	"./assets/img/icons/go.svg": 8501,
	"./assets/img/icons/hindi.svg": 5237,
	"./assets/img/icons/hive.svg": 6285,
	"./assets/img/icons/html.svg": 2100,
	"./assets/img/icons/instagram.png": 4301,
	"./assets/img/icons/japanese.svg": 4858,
	"./assets/img/icons/java.svg": 4931,
	"./assets/img/icons/javascript.svg": 6466,
	"./assets/img/icons/jquery.svg": 2885,
	"./assets/img/icons/kali.svg": 890,
	"./assets/img/icons/labview.jpg": 6239,
	"./assets/img/icons/linkedin.png": 99,
	"./assets/img/icons/links.png": 7386,
	"./assets/img/icons/linux.svg": 5203,
	"./assets/img/icons/logisticregression.svg": 1285,
	"./assets/img/icons/machinelearning.svg": 6700,
	"./assets/img/icons/macos.svg": 2834,
	"./assets/img/icons/matplotlib.svg": 5887,
	"./assets/img/icons/mongodb.svg": 975,
	"./assets/img/icons/ms_office.svg": 3594,
	"./assets/img/icons/net.svg": 9700,
	"./assets/img/icons/neuralnetwork.svg": 9264,
	"./assets/img/icons/nodejs.svg": 8202,
	"./assets/img/icons/numpy.svg": 4892,
	"./assets/img/icons/pandas.svg": 3300,
	"./assets/img/icons/powerbi.svg": 8665,
	"./assets/img/icons/pyspark.svg": 8142,
	"./assets/img/icons/python.svg": 1849,
	"./assets/img/icons/react.svg": 6883,
	"./assets/img/icons/selenium.svg": 5615,
	"./assets/img/icons/sklearn.svg": 8561,
	"./assets/img/icons/sql.svg": 9129,
	"./assets/img/icons/swift.svg": 5204,
	"./assets/img/icons/tableau.svg": 9195,
	"./assets/img/icons/tensorflow.svg": 9288,
	"./assets/img/icons/tensorflow2.svg": 1850,
	"./assets/img/icons/typescript.svg": 8482,
	"./assets/img/icons/unity.svg": 5650,
	"./assets/img/icons/vanillajs.svg": 7161,
	"./assets/img/icons/vuejs.svg": 6788,
	"./assets/img/icons/web.png": 5631,
	"./assets/img/icons/web.svg": 2255,
	"./assets/img/icons/window.svg": 4635,
	"./assets/img/icons/windows.svg": 7106,
	"./assets/img/icons/xml.svg": 4806,
	"./assets/img/icons/youtube.png": 7310,
	"./assets/img/icons/youtube.svg": 774,
	"./assets/img/me_and_coworks_bonding.JPEG": 3953,
	"./assets/img/me_and_my_coach_after_big_fight.jpg": 7539,
	"./assets/img/me_dressed_nice.jpg": 7585,
	"./assets/img/me_graduating_with_AA_degree.JPG": 1927,
	"./assets/img/me_promoting_goodvalues_in_esthetic_way.jpg": 2912,
	"./assets/img/me_voluteering_as_test_subject.jpg": 4624,
	"./assets/img/me_with_lilBrother_after_he_foughtinstatechampionship.jpg": 5253,
	"./assets/img/me_working_at_HCA_as_pt_tech.jpg": 332,
	"./assets/img/professional_headshot_of_me.jpg": 5369,
	"./assets/img/sky.png": 4961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;